/* @flow */
import { action, observable } from 'mobx';

import AccountStore from 'stores/AccountStore';

export default class LocationStore extends AccountStore {
  @observable companies: Array<*> = [];

  @observable countries: Array<*> = [];

  @observable sites: Array<*> = [];

  @observable buildings: Array<*> = [];

  @observable room: Array<*> = [];

  @observable workspace: Array<*> = [];

  @observable locations = {
    active: [],
    archived: [],
  };

  @observable companyDetails: ?Object<*> = null;

  @observable countryDetails: ?Object<*> = null;

  @observable loading = false;

  @action
  async loadResource(path: string): Promise<void> {
    this.loadingResources = true;

    const resource: Promise<*> = await this.api
      .getResource(path)
      .then((success: *) => success)
      .catch((error: *) => this.errorMessage);

    this.loadingResources = false;

    return resource;
  }

  @action
  async loadLocationsByCompany(companyId: string): Promise<void> {
    this.loading = true;
    this.locations = await this.loadResource(`companies/${companyId}/locations`);
    this.loading = false;
  }

  @action
  async loadCompanyDetails(companyId: string): Promise<void> {
    this.companyDetails = await this.loadResource(`companies/${companyId}`);
  }

  @action
  async loadCountryDetails(companyId: string, countryId: string): Promise<void> {
    this.countryDetails = await this.loadResource(`companies/${companyId}/countries/${countryId}`);
  }
}
